(function () {
  "use strict";

  function splitFaqHeading(root) {
    // Only target the FAQ section (Expanse) you showed
    var headings = (root || document).querySelectorAll(
      '.page-width--narrow .section-header__title'
    );

    headings.forEach(function (h2) {
      // Only apply when this heading is followed by collapsible FAQ markup
      var wrapper = h2.closest('.page-width--narrow');
      if (!wrapper || !wrapper.querySelector('collapsible-elements')) return;

      // Prevent double-run (PJAX/theme editor reloads)
      if (h2.dataset.nayaSplit === "true") return;
      h2.dataset.nayaSplit = "true";

      var text = (h2.textContent || "").trim();
      if (!text) return;

      // If user already inserted a newline, don't interfere
      if (text.indexOf("\n") > -1) return;

      // Split after first sentence end: ?, !, or .
      var match = text.match(/^(.+?[?!\.])\s+(.+)$/);
      if (!match) return; // nothing to split

      var line1 = match[1].trim();
      var line2 = match[2].trim();

      h2.innerHTML =
        '<span class="faq-title-line-1">' + line1 + '</span>' +
        '<span class="faq-title-line-2">' + line2 + '</span>';
    });
  }

  function init() {
    splitFaqHeading(document);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("page:loaded", init); // Expanse PJAX
})();